import {
  IUseCreatePatient,
  useCreatePatient,
} from "../../common/patient/patient";

export const useCreatePatientCaller = (): IUseCreatePatient => {
  const {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading
  } = useCreatePatient();

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading
  };
};
